import {
  Cancel01Icon,
  CheckmarkBadge01Icon
} from "@hugeicons-pro/core-solid-rounded";
import { BadgeVariant } from "shared/components";

export const OCROLUS_FAIL_STATUSES = ["UNABLE_TO_PROCESS", "UNSUPPORTED"];

export const INCOME_STATUSES = {
  failed: "Rejected",
  verified_with_warnings: "Warning",
  verified: "Accepted"
};

export const INCOME_SOURCE_BADGE_STATUSES_MAP = {
  Rejected: {
    variant: BadgeVariant.ERROR,
    title: "Rejected",
    icon: Cancel01Icon,
    iconSize: 16,
    iconColor: "text-danger-500"
  },
  Warning: {
    variant: BadgeVariant.WARNING,
    title: "Verified with warnings",
    icon: CheckmarkBadge01Icon,
    iconSize: 12,
    iconColor: "text-warning-500"
  },
  Accepted: {
    variant: BadgeVariant.SUCCESS,
    title: "Verified",
    icon: CheckmarkBadge01Icon,
    iconSize: 12,
    iconColor: "text-success-600"
  }
};
